import ReactDOMServer from 'react-dom/server';
import $ from 'jquery';
import appAjax from '../helpers/ajax';
import { useEffect, useState } from 'react';
import Loader from '../components/Loader';

export default function ModalHistory(props) {
  const [files, setFiles] = useState([]);
  const [elModal, setElModal] = useState(null);
  const [elFormFilter, setElFormFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [page, setPage] = useState(1);
  const [resultTime, setResultTime] = useState(null);

  const doLoadData = () => {
    if (resultTime === null) return; // Skip initial load

    var elForm = $(elModal).find('#web_modal_form_history');
    var dateFrom = elForm.find('input[name=date_from]').val() || null;
    var dateTo = elForm.find('input[name=date_to]').val() || null;

    var url = appAjax.apiBaseUrl + '/files?page=' + page;

    if (dateFrom) url += '&from=' + encodeURIComponent(dateFrom);
    if (dateTo) url += '&to=' + encodeURIComponent(dateTo);

    appAjax._ajax_send(null, {
      type: 'GET',
      beforeSend: () => {
        setFiles([]);
        setIsLoading(true);
        setErrorMessage(null);
        appAjax._ui_forminput_setenabled(elForm, false);
      },
      success: (response) => {
        setFiles(response.data);
      },
      error: (response) => {
        setErrorMessage(response.message || 'Failed to load files');
      },
      always: () => {
        setIsLoading(false);
        appAjax._ui_forminput_setenabled(elForm, true);
      }
    }, 'Fetching files...', url);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    setResultTime(Date.now());
  };

  const onClickLoadMore = (e) => {
    e.preventDefault();
    setPage(prevPage => prevPage + 1);
    setResultTime(Date.now());
  };

  const onClickPrev = (e) => {
    e.preventDefault();
    setPage(prevPage => Math.max(prevPage - 1, 1));
    setResultTime(Date.now());
  }

  const onClickOpenMaps = (e) => {
    e.preventDefault();
    const lat = parseFloat(e.target.getAttribute('data-lat'));
    const lng = parseFloat(e.target.getAttribute('data-lng'));
    props.onMapsOpen && props.onMapsOpen(lat, lng);
  };

  const onClickListActivities = (e) => {
    e.preventDefault();
    props.onListActivities && props.onListActivities();
  };

  useEffect(() => {
    doLoadData();
  }, [resultTime]);

  useEffect(() => {
    var tmp = $('#web_modal_history');
    setElModal(tmp);

    $(tmp).on('shown.bs.modal', () => {
      //-- Reset forms
      var elForm = $(tmp).find('#web_modal_form_history').first();
      setElFormFilter(elForm);
      elForm[0].reset();

      setFiles([]);
      setErrorMessage(null);
      setPage(1);
      setResultTime(Date.now());
    });
  }, []);

  return (
    <div
      className="modal"
      style={{ display: "none" }}
      tabIndex={-1}
      id="web_modal_history"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><i className="fa fa-history me-1"></i> Upload History</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>    
          <div className="modal-body">
            <form action="#" method="POST" id="web_modal_form_history" onSubmit={handleSubmit}
                className="d-flex align-items-end flex-wrap g-2" style={{marginBottom: 15}}>
              <div className="me-2" style={{marginRight: 10}}>
                <label htmlFor="date_from" className="form-label small mb-1">From</label>
                <input type="date" name="date_from" id="date_from" className="form-control form-control-sm" />
              </div>
              <div className="me-2" style={{marginRight: 10}}>
                <label htmlFor="date_to" className="form-label small mb-1">To</label>
                <input type="date" name="date_to" id="date_to" className="form-control form-control-sm" />
              </div>
              <div className="me-2 mt-1">
                <button type="submit" className="btn btn-primary btn-sm">
                  <i className="fa fa-filter me-1"></i> Filter
                </button>
                <button type="button" className="btn btn-light btn-sm ml-2" onClick={onClickListActivities}>
                  <i className="fa fa-list me-1"></i> Activities...
                </button>
              </div>
            </form>

            <div className="table-responsive">
              <table className="table table-bordered table-striped table-condensed" style={{fontSize: '10pt', marginBottom: 0}}>
                <thead>
                  <tr>
                    <th style={{ width: 150 }}>Preview</th>
                    <th>Title</th>
                  </tr>
                </thead>
                <tbody className="history_table_body">
                  {isLoading ? (
                    <tr>
                      <td colSpan={2} style={{ textAlign: "center" }}>
                        <Loader />
                      </td>
                    </tr>
                  ) : null}
                  {files.map(file => (
                    <tr key={file.created_at}>
                      <td>
                        {file.url_preview && (
                          <img
                            src={file.url_preview}
                            className="img-fluid"
                            style={{ width: '100%', borderRadius: 3 }}
                            alt="preview"
                          />
                        )}
                        {file.geolocation && (
                          <button className="btn btn-link btn-sm text-muted w-100" style={{fontSize: '11px'}}
                            onClick={onClickOpenMaps} data-lat={file.geolocation.lat} data-lng={file.geolocation.lng}>
                            <i className="fa fa-map-marker-alt"></i> View Location
                          </button>
                        )}
                      </td>
                      <td>
                        <div style={{ marginBottom: 5 }} className="text-muted" >
                          <i className="fa fa-calendar"></i> {file.long_created_at} | Size: {file.file_size}
                        </div>
                        <a
                          href={file.url}
                          target="_blank"
                          style={{
                            fontSize: '10pt',
                            display: "inline-block",
                            textOverflow: "ellipsis",
                            textWrap: "nowrap",
                            maxWidth: '300px',
                            overflow: "hidden",
                            verticalAlign: "top",
                            marginBottom: 5,
                          }}
                        >
                          <i className="fa fa-file" /> {file.file_name}
                        </a>
                        <div style={{ verticalAlign: "top" }}>{file.file_title}</div>
                      </td>
                    </tr>
                  ))}
                  {!isLoading && errorMessage ? (
                    <tr>
                      <td colSpan={2} style={{ textAlign: "center" }}>
                        <div className="text-danger"><i className="fa fa-times"></i> {errorMessage}</div>
                      </td>
                    </tr>
                  ) : null}
                  {!isLoading && !errorMessage && (files.length == 0) && (page == 1) ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center" }}>
                          <div className="text-muted"><i className="fa fa-info-circle"></i> No files found.</div>
                        </td>
                      </tr>
                    ) : null}
                  {!isLoading && !errorMessage && ((files.length > 0) || (page > 1)) ? (
                      <tr>
                        <td colSpan={2}>
                          {page > 1 && (
                            <button className="btn btn-sm btn-outline-secondary me-2" onClick={onClickPrev}
                              style={{ marginRight: 10 }}>
                              <i className="fa fa-chevron-left"></i> Previous
                            </button>
                          )}
                          <span style={{ marginRight: 10 }}>Page {page}</span>
                          {files.length >= 10 && (
                            <button className="btn btn-sm btn-outline-secondary" onClick={onClickLoadMore}>
                              Next <i className="fa fa-chevron-right"></i></button>
                          )}
                        </td>
                      </tr>
                    ) : null}
                </tbody>
              </table>
            </div>

          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

  );
};
